import OpenAI from "openai";
import { CompanyDTO } from "./company";
import { ConversationMessageRole, LLMModels } from "./conversation-message";
import { CursorPaginatedResponse } from "./pagination";
import { Nullable } from "./utils";

export type AIMessage = OpenAI.ChatCompletionMessageParam;
export type AIConversation = AIMessage[];

export const CONVERSATION_TITLE_MAX_LENGTH = 80;

/**
 * Excerpt of the message that matched a content search, used to render a
 * preview under the conversation title (Claude-style). Only present on
 * conversations returned by a `search` query when the match came from a
 * message body rather than the title/company.
 */
export type ConversationMatchedMessage = {
  messageId: string;
  role: ConversationMessageRole;
  snippet: string;
};

export type ConversationDTO = {
  id: string;
  createdAt: Date;
  lastMessageAt: Date;
  llmId: LLMModels;
  title: Nullable<string>;
  pinnedAt: Nullable<Date>;
  company: Nullable<CompanyDTO>;
  companyTargeted: Nullable<CompanyDTO>;
  matchedMessage?: ConversationMatchedMessage;
};

/**
 * Conversation feed paginated by last activity, plus the full set of pinned
 * conversations resolved separately. `pinned` is only populated on the first
 * page (no cursor, no search); on subsequent pages or while searching it is an
 * empty array, since the pinned section is rendered from the first page only.
 */
export type ConversationsListResponse =
  CursorPaginatedResponse<ConversationDTO> & {
    pinned: ConversationDTO[];
  };
